import { Pipe, PipeTransform } from '@angular/core';
import { constants } from '../constants';

/**
 * @author ejciro
 * @description Pipe que se usa en el ngFor de combos/bonos recomendados para filtrar los beneficios que no son de redes sociales
 */
@Pipe({
    name: 'FilterBenefitsWithoutSocialNetwork'
})
export class FilterBenefitsWithoutSocialNetworkPipe implements PipeTransform {
    transform(items: any[]): any {
        return items.filter(item => item.socialNetwork === constants.COMBOS_BENEFIT_WITHOUT_SOCIAL_NETWORK);
    }
}

/**
 * @author ejciro
 * @description Pipe que se usa en el ngFor de combos/bonos recomendados para filtrar los beneficios que son de redes sociales
 */
@Pipe({
    name: 'FilterBenefitsWithSocialNetwork'
})
export class FilterBenefitsWithSocialNetworkPipe implements PipeTransform {
    transform(items: any[]): any {
        return items.filter(item => item.socialNetwork !== constants.COMBOS_BENEFIT_WITHOUT_SOCIAL_NETWORK);
    }
}